module.exports = __webpack_public_path__ + "static/media/spange-yellow.2b31890a.jpg";